exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapsible .collapsible-trigger{cursor:pointer}.collapsible .collapsible-trigger svg{width:1.65rem;height:1.65rem;transition:all .27s cubic-bezier(0.215, 0.61, 0.355, 1);transform:rotate(0deg);position:relative;left:-3px;top:-1px}.collapsible .collapsible-content{height:0;overflow:hidden;transition:all .32s cubic-bezier(0.215, 0.61, 0.355, 1),overflow .1s cubic-bezier(0.215, 0.61, 0.355, 1) .35s;position:relative}.collapsible.open .collapsible-trigger svg{transform:rotate(180deg)}", ""]);

// exports
